import { render, staticRenderFns } from "./invigilatorInfo.vue?vue&type=template&id=361bd9ae&scoped=true&"
import script from "./invigilatorInfo.vue?vue&type=script&lang=js&"
export * from "./invigilatorInfo.vue?vue&type=script&lang=js&"
import style0 from "./invigilatorInfo.vue?vue&type=style&index=0&id=361bd9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361bd9ae",
  null
  
)

export default component.exports